import { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Spinner } from "reactstrap";

import "./tinyEditor.scss";
import { tinyEditorConfig, tinyEditorTypes } from "../../enums/tinyEditorTypes";

const TinyEditor = ({ contentStyle = "", handleEditorChange, loading, type = tinyEditorTypes.CODE, editable = null, value }) => {
  const editorRef = useRef(null);
  const config = tinyEditorConfig[type];

  if (loading) {
    return <Spinner color="primary" />;
  }
  
  return (
    <div className="tinyeditor-wrapper">
      <Editor
        tinymceScriptSrc="/tinymce/tinymce.min.js"
        licenseKey="gpl"
        value={value ?? ""}
        onEditorChange={(content) => {
          handleEditorChange(content);
        }}
        onInit={(_evt, editor) => {
          editorRef.current = editor
        }}
        init={{
          height: 500,
          toolbar: editable ? false : config.toolbar,
          plugins: config.plugins,
          menubar: false,
          font_size_formats: '8px 10px 12px 14px 18px 24px 36px',
          content_style: contentStyle,
          promotion: false,
          ...config.init
        }}
        readonly= {editable}
      />
    </div>
  );
};

export default TinyEditor;
